import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DocsLayout from './DocsLayout';
import DocsHome from './DocsHome';
import DocsWhitepaper from './DocsWhitepaper';
import DocsRoadmap from './DocsRoadmap';

const DocsApp = () => {
    return (
        <Routes>
            <Route path="/" element={<DocsLayout />}>
                <Route index element={<DocsHome />} />
                <Route path="whitepaper" element={<DocsWhitepaper />} />
                <Route path="roadmap" element={<DocsRoadmap />} />
                
                {/* Placeholders for future pages */}
                <Route path="getting-started" element={<div style={{ textAlign: 'center', padding: '4rem' }}><h2 style={{fontSize: '2rem', marginBottom: '1rem'}}>Hızlı Başlangıç</h2><p>Çok yakında...</p></div>} />
                <Route path="api" element={<div style={{ textAlign: 'center', padding: '4rem' }}><h2 style={{fontSize: '2rem', marginBottom: '1rem'}}>API Referansı</h2><p>Çok yakında...</p></div>} />
                <Route path="security" element={<div style={{ textAlign: 'center', padding: '4rem' }}><h2 style={{fontSize: '2rem', marginBottom: '1rem'}}>Güvenlik & KVKK</h2><p>Çok yakında...</p></div>} />

                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
};

export default DocsApp;
